import { AlertModalType } from "../../../system/types/modal/Modal";
import Swal from "sweetalert2";

const successModal = (
  type: AlertModalType,
  message?: string,
  content?: string
) => {
  return Swal.fire({
    title:
      "<div style='font-family:Noto sans CJK KR;font-size:20px;'>" +
      message +
      "</div>",
    icon: "success",
    showConfirmButton: false,
    timer: 1500,
  });
};

export default successModal;
